import React, { useEffect } from "react";
import { Form, Input, DatePicker, Row, Col, Button, Select } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";


const { Option } = Select;

const PatientForm = ({ form, formData }) => {

  const { t } = useTranslation();

  useEffect(() => {
    if (formData) {
      const formattedFormData = {
        ...formData,
        date_of_birth: formData.date_of_birth
          ? moment(formData.date_of_birth)
          : null,
      };
      form.setFieldsValue(formattedFormData);
    }
  }, [formData, form]);

  return (
    <Form form={form} layout="vertical">
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="salutation"
            label={t('common.salutation')}
            rules={[
              { required: true, message: t("validation.pleaseEnter", { field: t("common.salutation") }, "!") },
            ]}
          >
            <Select placeholder="Select a salutation">
              <Option value="Mr.">Mr.</Option>
              <Option value="Miss.">Miss.</Option>
              <Option value="Mrs.">Mrs.</Option>
              <Option value="Ms.">Ms.</Option>
              <Option value="Dr.">Dr.</Option>
              <Option value="Prof.">Prof.</Option>
              <Option value="A/Prof.">A/Prof.</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="first_name"
            label={t('common.firstName')}
            rules={[
              {
                required: true, message: t("validation.pleaseEnter", { field: t("common.firstName") }, "!")
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="last_name"
            label={t('common.lastname')}
            rules={[{ required: true, message: t("validation.pleaseEnter", { field: t("common.lastname") }, "!") }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="phone_number"
            label={t('tableHeader.phoneNumber')}
            rules={[
              { required: true, message: t("validation.pleaseEnter", { field: t("tableHeader.phoneNumber") }, "!") },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="email_address"
            label={t("common.emailAddress")}
            rules={[
              { required: true, message: t("validation.pleaseEnter", { field: t("common.emailAddress") }, "!") },
            ]}
          >
            <Input
              disabled
              style={{
                backgroundColor: "#e8e8e8",
                color: "black",
                cursor: "not-allowed",
              }}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="gender"
            label={t("tableHeader.gender")}
            rules={[{ required: true, message: t("validation.pleaseEnter", { field: t("tableHeader.gender") }, "!") }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="date_of_birth"
            label={t("common.dob")}
            rules={[
              { required: true, message: t("validation.pleaseEnter", { field: t("common.dateOfBirth") }, "!") },
            ]}
          >
            <DatePicker format="YYYY-MM-DD" />
          </Form.Item>
        </Col>
      </Row>
      <Form.List name="allergies">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, fieldKey, ...restField }) => (
              <Row gutter={16} key={key}>
                <Col span={7}>
                  <Form.Item
                    {...restField}
                    name={[name, "allergy_type"]}
                    fieldKey={[fieldKey, "allergy_type"]}
                    label={t("patientPage.allergyType")}
                    rules={[
                      { required: true, message: t("validation.missingAllergyType") },
                    ]}
                  >
                    <Select placeholder={t('patientPage.selectAllergyType')}>
                      <Option value="drug">{t('patientPage.drug')}</Option>
                      <Option value="no known drug allergy">
                        {t('patientPage.noKnownDrugAllergy')}
                      </Option>
                      <Option value="food">{t("patientPage.food")}</Option>
                      <Option value="no known food allergy">
                        {t('patientPage.noKnownFoodAllergy')}
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    {...restField}
                    name={[name, "allergy"]}
                    fieldKey={[fieldKey, "allergy"]}
                    label={t('patientPage.allergy')}
                    rules={[{ message: t('validation.missingAllergy') }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    {...restField}
                    name={[name, "reaction"]}
                    fieldKey={[fieldKey, "reaction"]}
                    label={t("patientPage.reaction")}
                    rules={[{ message: t('validation.missingReaction') }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item
                    {...restField}
                    name={[name, "severity"]}
                    fieldKey={[fieldKey, "severity"]}
                    label={t('patientPage.severity')}
                    rules={[
                      { required: true, message: "Input should be 1, 2 or 3" },
                    ]}
                    getValueFromEvent={(value) => Number(value.target.value)}
                  >
                    <Input type="number" min={1} max={3} />
                  </Form.Item>
                </Col>
                <Col span={1}>
                  <Button type="link" onClick={() => remove(name)}>
                    {t("common.remove")}
                  </Button>
                </Col>
              </Row>
            ))}
            <Form.Item>
              <Button type="dashed" onClick={() => add()} block>
                {t("patientPage.addAllergy")}
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default PatientForm;
